import { Field } from "@progress/kendo-react-form";
import { useGetUserProfileQuery } from "../../../../redux/api/BaseApi";
import Description from "./Description";

export const DESCRIPTION_LOWERCASE = "description";

export const TicketDescription = () => {
  const { data } = useGetUserProfileQuery();
  return (
    <Field
      id={DESCRIPTION_LOWERCASE}
      name={DESCRIPTION_LOWERCASE}
      label={data ? data.Phrases.Description : ""}
      component={Description}
    />
  );
};
